import * as types from './mutations-type'

export const setSectors = ({ commit }, payload) => {
    commit(types.SECTORS, payload)
}

export const setCategory = ({ commit }, payload) => {
    commit(types.CATEGORY, payload)
}

export const setSubCategory = ({ commit }, payload) => {
    commit(types.SUB_CATEGORY, payload)
}

export const setSubSubCategory = ({ commit }, payload) => {
    commit(types.SUB_SUB_CATEGORY, payload)
}

export const setSectorPred = ({ commit }, payload) => {
    commit(types.SECTORPRED, payload)
}

export const setCatPred = ({ commit }, payload) => {
    commit(types.CATEGORYPRED, payload)
}

export const setMailingPred = ({ commit }, payload) => {
    commit(types.MAILINGTYPEPRED, payload)
}

export const setSecComPred = ({ commit }, payload) => {
    commit(types.SECCOMPANYPRED, payload)
}

export const setProductRawData = ({ commit }, payload) => {
    commit(types.RAW_DATA, payload)
}

export const setEntryDate = ({ commit }, payload) => {
    commit(types.PRODUCT_ENTRYDATE, payload)
}

export const setFauxCheck = ({ commit }, payload) => {
    commit(types.PRODUCT_FAUX_CHECK, payload)
}

export const setTipOnCard = ({ commit }, payload) => {
    commit(types.PRODUCT_TIP_ON_CARD, payload);
  };
  
  export const setHandwriting = ({ commit }, payload) => {
    commit(types.PRODUCT_HANDWRITING, payload);
  };

export const setFeeProduct = ({ commit }, payload) => {
    commit(types.PRODUCT_FEE_PRODUCT, payload)
}

export const setPerscription = ({ commit }, payload) => {
    commit(types.PRODUCT_PERSCRIPTION, payload)
}

export const setIsHphsa = ({ commit }, payload) => {
    commit(types.PRODUCT_IS_HPHSA, payload)
}

export const setGender = ({ commit }, payload) => {
    commit(types.PRODUCT_GENDER, payload)
}

export const setCiti = ({ commit }, payload) => {
    commit(types.PRODUCT_CITI, payload)
}

export const setOfferOrigin = ({ commit }, payload) => {
    commit(types.PRODUCT_OFFER_ORIGIN, payload)

}
export const setIsMobile = ({ commit }, payload) => {
    commit(types.PRODUCT_ISMOBILE, payload)
}

export const setIsPrescreen = ({ commit }, payload) => {
    commit(types.PRODUCT_ISPRESCREEN, payload)
}

export const setGroupSize = ({ commit }, payload) => {
    commit(types.PRODUCT_GROUP_SIZE, payload)
}

export const setFaceAmount = ({ commit }, payload) => {
    commit(types.PRODUCT_FACE_AMOUNT, payload)
}

export const setTermLength = ({ commit }, payload) => {
    commit(types.PRODUCT_TERM_LENGTH, payload)
}

export const setIssueType = ({ commit }, payload) => {
    commit(types.PRODUCT_ISSUE_TYPE, payload)
}

export const setRiders = ({ commit }, payload) => {
    commit(types.PRODUCT_RIDERS, payload)
}

export const setStateSpecific = ({ commit }, payload) => {
    commit(types.PRODUCT_STATE_SPECIFIC, payload)
}

export const setOfferExpiry = ({ commit }, payload) => {
    commit(types.PRODUCT_OFFER_EXPIRY_DATE, payload)
}

export const setPersonalization = ({ commit }, payload) => {
    commit(types.PRODUCT_PERSONALIZATION, payload)
}

export const setProductHeadline = ({ commit }, payload) => {
    commit(types.PRODUCT_PRODUCT_HEADLINE, payload)
}

export const setProductName = ({ commit }, payload) => {
    commit(types.PRODUCT_PRODUCT_NAME, payload)
}

export const setWorksiteVoluntary = ({ commit }, payload) => {
    commit(types.PRODUCT_WORKTYPE_VOLUNTARY, payload)
}

export const setCommunicationType = ({ commit }, payload) => {
    commit(types.PRODUCT_COMMUNICATION_TYPE, payload)
}

export const setStateProvince = ({ commit }, payload) => {
    // PATCH added for JIRAID-3335
    payload = payload.filter((v)=>v!=0)
    commit(types.PRODUCT_STATE_PROVINCE, payload)
}

export const setAudience = ({ commit }, payload) => {
    commit(types.PRODUCT_AUDIENCE, payload)
}

export const setMediaChannel = ({ commit }, payload) => {
    commit(types.PRODUCT_MEDIA_CHAN, payload)
}

export const setMailingType = ({ commit }, payload) => {
    commit(types.PRODUCT_MAILING_TYPE, payload)
}

export const setCampaignLang = ({ commit }, payload) => {
    commit(types.PRODUCT_CAMPAIGN_LANGUAGE, payload)
}

export const setBusinessContent = ({ commit }, payload) => {
    commit(types.PRODUCT_BUSINESS_CONTENT, payload)
}

export const setAffinity = ({ commit }, payload) => {
    commit(types.PRODUCT_AFFINITY, payload)
}

export const setCompanies = ({ commit }, payload) => {
    commit(types.PRODUCT_COMPANIES, payload)
}

export const setResponseMechanism = ({ commit }, payload) => {
    commit(types.PRODUCT_RESPONSE_MECHANISM, payload)
}

export const setAncillaryProducts = ({ commit }, payload) => {
    commit(types.PRODUCT_ANCILARY_PRODUCTS, payload)
}

export const setTargetMarket = ({ commit }, payload) => {
    commit(types.PRODUCT_TARGET_MARKET, payload)
}

export const setVarientEntryId = ({ commit }, payload) => {
    commit(types.PRODUCT_VARIENT_ENTRY_ID, payload)
}

export const setVariantType = ({ commit }, payload) => {
    commit(types.PRODUCT_VARIENT_TYPE, payload)
}

export const setSectorsDisplayData = ({ commit }, payload) => {
    commit(types.PRODUCT_SECTOR_DISPLAYABLE, payload)
}

export const setSectorsSubmittable = ({ commit }, payload) => {
    commit(types.PRODUCT_SECTOR_SUBMITTABLE, payload)
}

// export const setSelectedSubCategory = ({commit}, payload) => {
//     commit(types.PRODUCT_SUBCATEGORY, payload)
// }

// export const getSelectedSubSubCategory = ({commit}, payload) => {
//     commit(types.PRODUCT_SUBSUBCATEGORY, payload)
// }

export const setProductAge = ({ commit }, payload) => {
    commit(types.PRODUCT_AGE, payload)
}

export const setProductIncome = ({ commit }, payload) => {
    commit(types.PRODUCT_INCOME, payload)
}

export const setSignOn1AcceleretorPer = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_ACCELERETOR_PER, payload)
}

export const setSignOn2AcceleretorPer = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_ACCELERETOR_PER, payload)
}

export const setSignOn3AcceleretorPer = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_ACCELERETOR_PER, payload)
}

export const setSignOn1AcceleretorType = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_ACCELERETOR_TYPE, payload)
}

export const setSignOn2AcceleretorType = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_ACCELERETOR_TYPE, payload)
}

export const setSignOn3AcceleretorType = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_ACCELERETOR_TYPE, payload)
}

export const setSignOn1LimitSpecificCategory = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_LIMIT_SPECIFIC_CATEGORY, payload)
}

export const setSignOn2LimitSpecificCategory = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_LIMIT_SPECIFIC_CATEGORY, payload)
}

export const setSignOn3LimitSpecificCategory = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_LIMIT_SPECIFIC_CATEGORY, payload)
}

export const setSignOn1FixedDate = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_FIXED_DATE, payload)
}

export const setSignOn2FixedDate = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_FIXED_DATE, payload)
}

export const setSignOn3FixedDate = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_FIXED_DATE, payload)
}

export const setOngoingIncentive = ({ commit }, payload) => {
    commit(types.ONGOING_INCENTIVE, payload)
}

export const setSignOn1IncentiveType = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE_TYPE, payload)
}

export const setSignOn2IncentiveType = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE_TYPE, payload)
}

export const setSignOn3IncentiveType = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE_TYPE, payload)
}

export const setSignOn1IncentiveValue = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE_VALUE, payload)
}

export const setSignOn2IncentiveValue = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE_VALUE, payload)
}

export const setSignOn3IncentiveValue = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE_VALUE, payload)
}

export const setSignOn1IncentiveWindowMonth = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE_WINDOW_MONTH, payload)
}

export const setSignOn2IncentiveWindowMonth = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE_WINDOW_MONTH, payload)
}

export const setSignOn3IncentiveWindowMonth = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE_WINDOW_MONTH, payload)
}

export const setSignOn1MaxAward = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_MAX_AWARD, payload)
}

export const setSignOn2MaxAward = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_MAX_AWARD, payload)
}

export const setSignOn3MaxAward = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_MAX_AWARD, payload)
}

export const setSignOn1IncentiveMaxSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE_MAX_SPEND, payload)
}

export const setSignOn2IncentiveMaxSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE_MAX_SPEND, payload)
}

export const setSignOn3IncentiveMaxSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE_MAX_SPEND, payload)
}

export const setSignOn1IncentiveMinSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE_MIN_SPEND, payload)
}

export const setSignOn2IncentiveMinSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE_MIN_SPEND, payload)
}

export const setSignOn3IncentiveMinSpend = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE_MIN_SPEND, payload)
}

export const setSignOn1Incentive = ({ commit }, payload) => {
    commit(types.SIGN_ON_1_INCENTIVE, payload)
}

export const setSignOn2Incentive = ({ commit }, payload) => {
    commit(types.SIGN_ON_2_INCENTIVE, payload)
}

export const setSignOn3Incentive = ({ commit }, payload) => {
    commit(types.SIGN_ON_3_INCENTIVE, payload)
}

//mortgage

export const setRefinance = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_REFINANCE, payload)
}
export const set_jumbo_non_conforming = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_JUMBO_NON_CONFORMING, payload)
}
export const set_va = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_VA, payload)
}
export const set_fha = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_FHA, payload)
}
export const set_conventional = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_CONVENTIONAL, payload)
}
export const set_usda = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_USDA, payload)
}
export const set_correspondent_lending = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_CORRESPONDENT_LENDING, payload)
}
export const set_application_type = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_APPLICATION_TYPE, payload)
}
export const set_offered_loan_amount = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_OFFERED_LOAN_AMOUNT, payload)
}
export const set_maximum_loan_amount = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_MAXIMUM_LOAN_AMOUNT, payload)
}
export const set_minimum_loan_amount = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_MINIMUM_LOAN_AMOUNT, payload)
}
export const set_loan_term_months = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_LOAN_TERM_MONTHS, payload)
}
export const set_offered_apr = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_OFFERED_APR, payload)
}
export const set_upper_apr = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_UPPER_APR, payload)
}
export const set_lower_apr = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_LOWER_APR, payload)
}
export const set_rate_type = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_RATE_TYPE, payload)
}
export const set_introductory_apr = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_INTRODUCTORY_APR, payload)
}
export const set_introductory_period_months = ({ commit }, payload) => {
    commit(types.MORTGAGE_LOANS_INTRODUCTORY_PERIOD_MONTHS, payload)
}

//travel

export const set_travel_debit_card_mentioned = ({ commit }, payload) => {
    commit(types.TRAVEL_DEBIT_CARD_MENTIONED, payload)
}
export const set_travel_credit_card_mentioned = ({ commit }, payload) => {
    commit(types.TRAVEL_CREDIT_CARD_MENTIONED, payload)
}
export const set_travel_credit_network = ({ commit }, payload) => {
    commit(types.TRAVEL_CREDIT_NETWORK, payload)
}

//delivery

export const set_delivery_method = ({ commit }, payload) => {
    commit(types.DELIVERY_DELIVERY_METHOD, payload)
}

export const set_delivery_type = ({ commit }, payload) => {
    commit(types.DELIVERY_DELIVERY_TYPE, payload)
}

export const set_delivery_postage = ({ commit }, payload) => {
    commit(types.DELIVERY_POSTAGE, payload)
}

export const set_delivery_pre_sorted = ({ commit }, payload) => {
    commit(types.DELIVERY_PRE_SORTED, payload)
}

export const set_delivery_package_type = ({ commit }, payload) => {
    commit(types.DELIVERY_PACKAGE_TYPE, payload)
}

//retail

export const set_retail_debit_card_mentioned = ({ commit }, payload) => {
    commit(types.RETAIL_CREDIT_CARD_MENTIONED, payload)
}

// payment card
export const setPaymentCardSecondaryCcardLevel = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_SECONDARY_CARD_LEVEL, payload)
}
export const setPaymentCardAnnualFeeDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_ANNUAL_FEE_DETAILS, payload)
}
export const setPaymentCardApplicationType = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_APPLICATION_TYPE, payload)
}
export const setPaymentCardBalanceTransferIntroductoryApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_APR, payload)
}
export const setPaymentCardBalanceTransferIntroductoryFeeDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_DETAILS, payload)
}
export const setPaymentCardBalanceTransferIntroductoryFeePeriodMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD_MONTHS, payload)
}
export const setPaymentCardBalanceTransferIntroductoryMaximumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE, payload)
}
export const setPaymentCardBalanceTransferIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setPaymentCardBalanceTransferIntroductoryPeriodMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_PERIOD_MONTHS, payload)
}
export const setPaymentCardBalanceTransferIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE, payload)
}
export const setPaymentCardBalanceTransferMaximunFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE, payload)
}
export const setPaymentCardBalanceTransferMinimumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_MINIMUM_FEE, payload)
}
export const setPaymentCardBalanceTransferRegularAprDetail = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_APR_DETAIL, payload)
}
export const setPaymentCardBalanceTransferRegularRateType = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE, payload)
}
export const setPaymentCardBalanceTransferUsageFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_BALANCE_TRANSFER_USAGE_FEE, payload)
}
export const setPaymentCardCardNetwork = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CARD_NETWORK, payload)
}
export const setPaymentCardCashAdvanceIntroductoryApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_APR, payload)
}
export const setPaymentCardCashAdvanceIntroductoryFeeDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_DETAILS, payload)
}
export const setPaymentCardCashAdvanceIntroductoryFeePeriodMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD_MONTHS, payload)
}
export const setPaymentCardCashAdvanceIntroductoryMaximumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE, payload)
}
export const setPaymentCardCashAdvanceIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setPaymentCardCashAdvanceIntroductoryPeriodMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_PERIOD_MONTHS, payload)
}
export const setPaymentCardCashAdvanceIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE, payload)
}
export const setPaymentCardCashAdvanceMaximumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_MAXIMUM_FEE, payload)
}
export const setPaymentCardCashAdvanceMinimumFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_MINIMUM_FEE, payload)
}
export const setPaymentCardCashAdvanceUsageFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_USAGE_FEE, payload)
}
export const setPaymentCardLateFeeDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_LATE_FEE_DETAILS, payload)
}
export const setPaymentCardMaximumCardLimit = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_MAXIMUM_CARD_LIMIT, payload)
}
export const setPaymentCardMonthlyMaintenanceFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_MONTHLY_MAINTENENCE_FEE, payload)
}
export const setPaymentCardStandardMonthlyMaintenanceFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_STANDARD_MONTHLY_MAINTENENCE_FEE, payload)
}
export const setPaymentCardMinimumCardLimit = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_MINIMUM_CARD_LIMIT, payload)
}
export const setPaymentCardOverlimitFeeDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_OVERLIMIT_FEE_DETAILS, payload)
}
export const setPaymentCardPerchaseRegularRateType = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PERCHASE_REGULAR_RATE_TYPE, payload)
}
export const setPaymentCardPrimaryCardLevel = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PRIMARY_CARD_LEVEL, payload)
}
export const setPaymentCardProductID = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PRODUCT_ID, payload)
}
export const setPaymentCardPurchaseIntroductoryApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PURCHASE_INTRODUCTORY_APR, payload)
}
export const setPaymentCardPurchaseIntroductoryPeriodMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PURCHASE_INTRODUCTORY_PERIOD_MONTHS, payload)
}
export const setPaymentCardPurchaseRegularAprDetail = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PURCHASE_REGULAR_APR_DETAIL, payload)
}
export const setPaymentCardReloadable = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_RELOADABLE, payload)
}
export const setPaymentCardRewardProgram = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_REWARD_PROGRAM, payload)
}
export const setPaymentCardRewardProgramEmphasis = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_REWARD_PROGRAM_EMPHASIS, payload)
}
export const setPaymentCardRewardProgramRate = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_REWARD_PROGRAM_RATE, payload)
}
export const setPaymentCardSecondaryCardLevel = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_SECONDARY_CARD_LEVEL, payload)
}
export const setPaymentCardPenaltyApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PENALTY_APR, payload)
}
export const setPaymentCardPenaltyAprDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PENALTY_APR_DETAILS, payload)
}
export const setPaymentCardTier1AnnualFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_ANNUAL_FEE, payload)
}
export const setPaymentCardTier1BalanceTransferRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_BALANCE_TRANSFER_REGULAR_APR, payload)
}
export const setPaymentCardTier1LateFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_LATE_FEE, payload)
}
export const setPaymentCardTier1OverlimitFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_OVERLIMIT_FEE, payload)
}
export const setPaymentCardTier1PurchaseRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_PURCHASE_REGULAR_APR, payload)
}
export const setPaymentCardTier2AnnualFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_ANNUAL_FEE, payload)
}
export const setPaymentCardTier2BalanceTransferRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_BALANCE_TRANSFER_REGULAR_APR, payload)
}
export const setPaymentCardTier2LateFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_LATE_FEE, payload)
}
export const setPaymentCardTier2OverlimitFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_OVERLIMIT_FEE, payload)
}
export const setPaymentCardTier2PurchaseRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_PURCHASE_REGULAR_APR, payload)
}
export const setPaymentCardTier3AnnualFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_ANNUAL_FEE, payload)
}
export const setPaymentCardTier3BalanceTransferRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_BALANCE_TRANSFER_REGULAR_APR, payload)
}
export const setPaymentCardTier3LateFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_LATE_FEE, payload)
}
export const setPaymentCardTier3OverlimitFee = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_OVERLIMIT_FEE, payload)
}
export const setPaymentCardTier3PurchaseRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_PURCHASE_REGULAR_APR, payload)
}
export const setPaymentCardTier1CashAdvanceRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_1_CASH_ADVANCE_REGULAR_APR, payload)
}
export const setPaymentCardTier2CashAdvanceRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_2_CASH_ADVANCE_REGULAR_APR, payload)
}
export const setPaymentCardTier3CashAdvanceRegularApr = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_TIER_3_CASH_ADVANCE_REGULAR_APR, payload)
}
export const setPaymentCardCashAdvanceRegularAprDetails = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_REGULAR_APR_DETAILS, payload)
}
export const setPaymentCardCashAdvanceRegularRateType = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE, payload)
}
export const setPaymentCardPromotionalPricingUsageOffer = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER, payload)
}
export const setPaymentCardPromotionalPricingUsageOfferMonths = ({ commit }, payload) => {
    commit(types.PAYMENT_CARD_PROMOTIONAL_PRICING_USAGE_OFFER_MONTHS, payload)
}

// telecom
export const setTelecomPlanFeatured = ({ commit }, payload) => {
    commit(types.TELECOM_PLAN_FEATURED, payload)
}
export const setTelecomFeaturedPlanName = ({ commit }, payload) => {
    commit(types.TELECOM_FEATURED_PLAN_NAME, payload)
}
export const setTelecomContractRequired = ({ commit }, payload) => {
    commit(types.TELECOM_CONTRACT_REQUIRED, payload)
}
export const setTelecomInternetSpeed = ({ commit }, payload) => {
    commit(types.TELECOM_INTERNET_SPEED, payload)
}
export const setTelecomMonthlyCost = ({ commit }, payload) => {
    commit(types.TELECOM_MONTHLY_COST, payload)
}
export const setTelecomLowerFeaturedMonthlyCost = ({ commit }, payload) => {
    commit(types.TELECOM_LOWER_FEATURED_MONTHLY_COST, payload)
}
export const setTelecomUpperFeaturedMonthlyCost = ({ commit }, payload) => {
    commit(types.TELECOM_UPPER_FEATURED_MONTHLY_COST, payload)
}
export const setTelecomActivationCharge = ({ commit }, payload) => {
    commit(types.TELECOM_ACTIVATION_CHARGE, payload)
}
export const setTelecomInstallationCharge = ({ commit }, payload) => {
    commit(types.TELECOM_INSTALLATION_CHARGE, payload)
}
export const setTelecomLocalCallingMonthlyCharge = ({ commit }, payload) => {
    commit(types.TELECOM_LOCAL_CALLING_MONTHLY_CHARGE, payload)
}
export const setTelecomLocalDistanceMonthlyCharge = ({ commit }, payload) => {
    commit(types.TELECOM_LOCAL_DISTANCE_MONTHLY_CHARGE, payload)
}
export const setTelecomLongDistanceMonthlyCharge = ({ commit }, payload) => {
    commit(types.TELECOM_LONG_DISTANCE_MONTHLY_CHARGE, payload)
}
export const setTelecomIntroductoryCost = ({ commit }, payload) => {
    commit(types.TELECOM_INTRODUCTORY_COST, payload)
}
export const setTelecomIntroductoryPeriodMonths = ({ commit }, payload) => {
    commit(types.TELECOM_INTRODUCTORY_PERIOD_MONTHS, payload)
}


// RETAIL
export const setRetailCreditCardMentioned = ({ commit }, payload) => {
    commit(types.RETAIL_CREDIT_CARD_MENTIONED, payload)
}

// social media
export const setMediaChannelNumberUpdatesTweets = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_NUMBER_UPDATES_TWEETS, payload)
}
export const setMediaChannelNumberFansFollowers = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_NUMBER_FANS_FOLLOWERS, payload)
}
export const setMediaChannelExternalLink = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_EXTERNAL_LINK, payload)
}

export const setMediaChannelElectronicType = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_ELECTRONIC_TYPE, payload)
}

export const setMediaChannelSocialMediaAddType = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_SOCIAL_MEDIA_ADD_TYPE, payload)
}

export const setProductPanelists = ({ commit }, payload) => {
    commit(types.PRODUCT_PANELISTS, payload)
}

// Banking actions
export const setBankingRewardProgramEmphasis = ({ commit }, payload) => {
    commit(types.BANKING_REWARD_PROGRAM_EMPHASIS, payload)
}
export const setBankingRewardProgram = ({ commit }, payload) => {
    commit(types.BANKING_REWARD_PROGRAM, payload)
}
export const setBankingCardType = ({ commit }, payload) => {
    commit(types.BANKING_CARD_TYPE, payload)
}
export const setBankingDebitCardMentioned = ({ commit }, payload) => {
    commit(types.BANKING_DEBIT_CARD_MENTIONED, payload)
}
export const setBankingCdApy = ({ commit }, payload) => {
    commit(types.BANKING_CD_APY, payload)
}
export const setBankingCdApr = ({ commit }, payload) => {
    commit(types.BANKING_CD_APR, payload)
}
export const setBankingMoneyMarketApy = ({ commit }, payload) => {
    commit(types.BANKING_MONEY_MARKET_APY, payload)
}
export const setBankingMoneyMarketApr = ({ commit }, payload) => {
    commit(types.BANKING_MONEY_MARKET_APR, payload)
}
export const setBankingSavingApy = ({ commit }, payload) => {
    commit(types.BANKING_SAVING_APY, payload)
}
export const setBankingSavingApr = ({ commit }, payload) => {
    commit(types.BANKING_SAVING_APR, payload)
}
export const setBankingCheckingApy = ({ commit }, payload) => {
    commit(types.BANKING_CHECKING_APY, payload)
}
export const setBankingCheckingApr = ({ commit }, payload) => {
    commit(types.BANKING_CHECKING_APR, payload)
}
export const setBankingFreeChecking = ({ commit }, payload) => {
    commit(types.BANKING_FREE_CHECKING, payload)
}
export const setBankingMinimumDeposit = ({ commit }, payload) => {
    commit(types.BANKING_MINIMUM_DEPOSIT, payload)
}

// Energy
export const setEnergyOfferPricePerKwh = ({ commit }, payload) => {
    commit(types.ENERGY_OFFER_PRICE_PER_KWH, payload)
}
export const setEnergyOfferPricePerKwh2 = ({ commit }, payload) => {
    commit(types.ENERGY_OFFER_PRICE_PER_KWH2, payload)
}
export const setEnergyOfferPricePerKwh3 = ({ commit }, payload) => {
    commit(types.ENERGY_OFFER_PRICE_PER_KWH3, payload)
}
export const setEnergyOfferPricePerKwh4 = ({ commit }, payload) => {
    commit(types.ENERGY_OFFER_PRICE_PER_KWH4, payload)
}
export const setEnergyTermLength = ({ commit }, payload) => {
    commit(types.ENERGY_TERM_LENGTH, payload)
}
export const setEnergyTermLength2 = ({ commit }, payload) => {
    commit(types.ENERGY_TERM_LENGTH2, payload)
}
export const setEnergyTermLength3 = ({ commit }, payload) => {
    commit(types.ENERGY_TERM_LENGTH3, payload)
}
export const setEnergyTermLength4 = ({ commit }, payload) => {
    commit(types.ENERGY_TERM_LENGTH4, payload)
}
export const setEnergyCancelFee = ({ commit }, payload) => {
    commit(types.ENERGY_CANCEL_FEE, payload)
}
export const setEnergyCancelFeeDetails = ({ commit }, payload) => {
    commit(types.ENERGY_CANCEL_FEE_DETAILS, payload)
}
export const setEnergyRateType = ({ commit }, payload) => {
    commit(types.ENERGY_RATE_TYPE, payload)
}
export const setEnergyRateType2 = ({ commit }, payload) => {
    commit(types.ENERGY_RATE_TYPE2, payload)
}
export const setEnergyRateType3 = ({ commit }, payload) => {
    commit(types.ENERGY_RATE_TYPE3, payload)
}
export const setEnergyRateType4 = ({ commit }, payload) => {
    commit(types.ENERGY_RATE_TYPE4, payload)
}

// Credit Card
export const setCreditCardTier1CashAdvanceIntroductoryPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_PERIOD, payload)
}

export const setCreditCardPromotionalOffer = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PROMOTIONAL_OFFER, payload)
}
export const setCreditCardTier1BalanceTransferIntroductionApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTION_APR, payload)
}
export const setCreditCardTier1BalanceTransferIntroductoryPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_BALANCE_TRANSFER_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardTier2BalanceTransferIntroductionApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTION_APR, payload)
}
export const setCreditCardTier2BalanceTransferIntroductoryPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardBalanceTransferIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE, payload)
}
export const setCreditCardTier2BalanceTransferIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_USAGE_FEE, payload)
}
export const setCreditCardBalanceTransferIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setCreditCardTier2BalanceTransferIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_BALANCE_TRANSFER_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setCreditCardBalanceTransferIntroductoryMaximumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_MAXIMUM_FEE, payload)
}
export const setCreditCardBalanceTransferIntroductoryFeePeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_INTRODUCTORY_FEE_PERIOD, payload)
}

// cash advance
export const setCreditCardCashAdvanceIntroductoryApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_APR, payload)
}
export const setCreditCardCashAdvanceIntroductoryAprPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_CASH_ADVANCE_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardTier2CashAdvanceIntroductoryApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_APR, payload)
}
export const setCreditCardCashAdvanceTier2IntroductoryAprPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_CASH_ADVANCE_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardCashAdvanceTier2IntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE, payload)
}
export const setCreditCardCashAdvanceIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setCreditCardCashAdvanceIntroductoryMaximumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_MAXIMUM_FEE, payload)
}
export const setCreditCardCashAdvanceIntroductoryFeePeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_FEE_PERIOD, payload)
}
export const setCreditCardCashAdvanceIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_INTRODUCTORY_USAGE_FEE, payload)
}

////purchase///

export const setCreditCardTier1PurchaseIntroductoryApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_APR, payload)
}
export const setCreditCardTier1PurchaseIntroductoryPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_1_PURCHASE_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardTier2PurchaseIntroductoryApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_APR, payload)
}
export const setCreditCardTier2PurchaseIntroductoryPeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_TIER_2_PURCHASE_INTRODUCTORY_PERIOD, payload)
}
export const setCreditCardPurchaseIntroductoryUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PURCHASE_INTRODUCTORY_USAGE_FEE, payload)
}
export const setCreditCardPurchaseIntroductoryMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PURCHASE_INTRODUCTORY_MINIMUM_FEE, payload)
}
export const setCreditCardPurchaseIntroductoryMaximumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PURCHASE_INTRODUCTORY_MAXIMUM_FEE, payload)
}
export const setCreditCardPurchaseIntroductoryFeePeriod = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PURCHASE_INTRODUCTORY_FEE_PERIOD, payload)
}


////2nd parts

////balance transfer ---2nd part

export const setCreditCardBalanceTransferRegularApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_REGULAR_APR, payload)
}
export const setCreditCardBalanceTransferRegularRateType = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_REGULAR_RATE_TYPE, payload)
}
export const setCreditCardBalanceTransferUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_USAGE_FEE, payload)
}
export const setCreditCardBalanceTransferMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_MINIMUM_FEE, payload)
}
export const setCreditCardBalanceTransferMaximumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_BALANCE_TRANSFER_MAXIMUM_FEE, payload)
}

// cash advance 2nd part--------------
export const setCreditCardCashAdvanceRegularApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_REGULAR_APR, payload)
}
export const setCreditCardCashAdvanceRegularRateType = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_REGULAR_RATE_TYPE, payload)
}
export const setCreditCardCashAdvanceUsageFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_USAGE_FEE, payload)
}
export const setCreditCardCashAdvanceMinimumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_MINIMUM_FEE, payload)
}
export const setCreditCardCashAdvanceMaximumFee = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_CASH_ADVANCE_MAXIMUM_FEE, payload)
}
//
export const setCreditCardPerchaseRegularApr = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PERCHASE_REGULAR_APR, payload)
}
export const setCreditCardPerchaseRegularRateType = ({ commit }, payload) => {
    commit(types.CREDIT_CARD_PERCHASE_REGULAR_RATE_TYPE, payload)
}

///----------------------------------------------


////

export const setMediaChannelDigitalSource = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_DIGITAL_SOURCE, payload)
}

export const setMuid = ({ commit }, payload) => {
    commit(types.MUID, payload)
}
export const setUserid = ({ commit }, payload) => {
    commit(types.USERID, payload)
}

export const setProductObservedTrafficSource = ({ commit }, payload) => {
    commit(types.PRODUCT_OBSERVED_TRAFFIC_SOURCE, payload)
}

export const setProductDmTmSource = ({ commit }, payload) => {
    commit(types.PRODUCT_DM_TM_SOURCE, payload)
}

export const removePanelist = ({ commit }, payload) => {
    commit(types.REMOVE_PANELIST, payload)
}

export const editPanelist = ({ commit }, payload) => {
    commit(types.EDIT_PANELIST, payload)
}

export const setPublication = ({ commit }, payload) => {
    commit(types.ADD_PUBLICATION, payload)
}

export const removePublication = ({ commit }, payload) => {
    commit(types.REMOVE_PUBLICATION, payload)
}

export const removeBanking = ({ commit }, payload) => {
    commit(types.REMOVE_BANKING, payload)
}

export const removePaymentCards = ({ commit }, payload) => {
    commit(types.REMOVE_PAYMENT_CARDS, payload)
}

export const removeCreditCards = ({ commit }, payload) => {
    commit(types.REMOVE_CREDIT_CARDS, payload)
}

export const removeEnergy = ({ commit }, payload) => {
    commit(types.REMOVE_ENERGY, payload)
}

export const removeMortgage = ({ commit }, payload) => {
    commit(types.REMOVE_MORTGAGE, payload)
}

export const removeRetail = ({ commit }, payload) => {
    commit(types.REMOVE_RETAIL, payload)
}

export const removeTelecom = ({ commit }, payload) => {
    commit(types.REMOVE_TELECOM, payload)
}

export const removeTravel = ({ commit }, payload) => {
    commit(types.REMOVE_TRAVEL, payload)
}

export const setProductId = ({ commit }, payload) => {
    commit(types.PRODUCT_ID, payload)
}

export const setCompanyImageData = ({ commit }, payload) => {
    commit(types.COMPANY_IMG_DATA, payload)
}

export const setCompanyAssociatedData = ({ commit }, payload) => {
    commit(types.COMPANY_ASSOCIATED_DATA, payload)
}

export const setCurrentCompanyPath = ({ commit }, payload) => {
    commit(types.CURRENT_COMPANY_PATH, payload)
}

export const setCurrentCompanyId = ({ commit }, payload) => {
    commit(types.CURRENT_COMPANY_ID, payload)
}

export const setLastWorkedUser = ({ commit }, payload) => {
    commit(types.LAST_WORKED_USER, payload)
}

export const setPrimaryCountry = ({ commit }, payload) => {
    commit(types.PRODUCT_PRIMARY_COUNTRY, payload)
}

export const setIndexName = ({ commit }, payload) => {
    commit(types.INDEX_NAME, payload)
}

export const setProductStatus = ({ commit }, payload) => {
    commit(types.PRODUCT_STATUS, payload)
}

export const setProductComment = ({ commit }, payload) => {
    commit(types.PRODUCT_PRODUCT_COMMENT, payload)
}

export const setIsAddProduct = ({ commit }, payload) => {
    commit(types.IS_ADDPRODUCT, payload)
}
export const setEcContentType = ({ commit }, payload) => {
    commit(types.EC_CONTENT_TYPE, payload)
}

// advertiser

export const setAdvertiserAddress = ({ commit }, payload) => {
    commit(types.ADVERTISER_ADDRESS, payload)
}
export const setAdvertiserCity = ({ commit }, payload) => {
    commit(types.ADVERTISER_CITY, payload)
}
export const setAdvertiserState = ({ commit }, payload) => {
    commit(types.ADVERTISER_STATE, payload)
}
export const setAdvertiserZipcode = ({ commit }, payload) => {
    commit(types.ADVERTISER_ZIPCODE, payload)
}
export const setAdvertiserPhone = ({ commit }, payload) => {
    commit(types.ADVERTISER_PHONE, payload)
}
export const setAdvertiserUrl = ({ commit }, payload) => {
    commit(types.ADVERTISER_URL, payload)
}

// promotions

export const setHoliday = ({ commit }, payload) => {
    commit(types.HOLIDAY, payload)
}
export const setSaleType = ({ commit }, payload) => {
    commit(types.SALE_TYPE, payload)
}
export const setPromotions = ({ commit }, payload) => {
    commit(types.PROMOTIONS, payload)
}
export const setPdfContent = ({ commit }, payload) => {
    commit(types.PDF_CONTENT, payload)
}

export const setCurrentPdf = ({ commit }, payload) => {
    commit(types.CURRENT_PDF, payload)
}

export const setEntryId = ({ commit }, payload) => {
    commit(types.ENTRY_ID, payload)
}

export const setEntryDateChanged = ({ commit }, payload) => {
    commit(types.ENTRY_DATE_CHANGED, payload)
}

export const setMobileDigtialFileType = ({ commit }, payload) => {
    commit(types.MOBILE_DIGITAL_FILE_TYPE, payload)
}


export const setMobileDigtialFileURL = ({ commit }, payload) => {
    commit(types.MOBILE_DIGITAL_FILE_URL, payload)
}
export const setMobileDigtialFileSize = ({ commit }, payload) => {
    commit(types.MOBILE_DIGITAL_FILE_SIZE, payload)
}
export const setMediaChannelName = ({ commit }, payload) => {
    commit(types.MEDIA_CHANNEL_NAME, payload)
}

export const setBannerProductPath = ({ commit }, payload) => {
    commit(types.BANNER_PRODUCT_PATH, payload)
}
export const setDocumentSizeByte = ({ commit }, payload) => {
    commit(types.DOCUMENT_SIZE_BYTE, payload)
}
export const setFileName = ({ commit }, payload) => {
    commit(types.FILE_NAME, payload)
}

export const setOriginalDocumentSize = ({ commit }, payload) => {
    commit(types.ORIGINAL_DOCUMENT_SIZE, payload)
}

export const setIsMobileProduct = ({ commit }, payload) => {
    commit(types.IS_MOBILE, payload)
}

export const setProductImg = ({ commit }, payload) => {
    commit(types.PRODUCT_IMG, payload)
}
export const setPDFCDNLINK = ({ commit }, payload) => {
    commit(types.PDF_CDN_LINK, payload)
}
export const setPDFCDNLINKORIG = ({ commit }, payload) => {
    commit(types.PDF_CDN_LINK_ORIG, payload)
}
export const setIsDeleted = ({ commit }, payload) => {
    commit(types.IS_DELETED, payload)
}
export const setDirectMailLogFile = ({ commit }, payload) => {
    commit(types.DIRECT_MAIL_LOGFILE, payload)
}
export const setAddedToDatabase = ({ commit }, payload) => {
    commit(types.ADDED_TO_DATABASE, payload)
}